import {
  Insurance,
  InsuranceAgreementsResolve,
  InsuranceAgreementsVM,
  InsurancePostResult,
  RmtInsuranceAgreement,
  UpdateInsurance,
  UpdateInsuranceStatus,
  UpdateInsuranceAgreement,
  SpResult,
  Role,
  GetUsersParams,
  LoginSummary,
  InsuranceIPANumber
} from '@/models'
import axios, { AxiosResponse } from 'axios'
const API_URL = 'Insurances'
import { getUserRole } from '@/components/admin/users/users.service'

export const getInsurances = async (
  pageNumber = 1,
  pageSize = 10
): Promise<AxiosResponse<Insurance[]>> => {
  const response = await axios.get(
    API_URL +
      `/GetAll?pageNumber=${pageNumber}&pageSize=${pageSize}&getCanceled=false`
  )
  return response || null
}
export const getIPANumbers = async (
  insurances?: string
): Promise<AxiosResponse<InsuranceIPANumber[]>> => {
  const url =
    insurances != null && insurances !== ''
      ? `${API_URL}/GetInsurancesIPANumber?insurances=${insurances}`
      : `${API_URL}/GetInsurancesIPANumber`
  const response = await axios.get(url)
  return response || null
}
export const getInsuranceAgreements = async (
  pageNumber = 1,
  pageSize = 10,
  searchQuery = '',
  doctorId: string | null = null
): Promise<AxiosResponse<RmtInsuranceAgreement[]>> => {
  let params = ''

  if (!doctorId) {
    params = `pageNumber=${pageNumber}&pageSize=${pageSize}&SearchQuery=${searchQuery}`
  } else {
    params += `&doctorId=${doctorId}`
  }

  const response = await axios.get(
    API_URL + `/GetInsuranceAgreements?${params}`
  )
  return response || null
}

export const getGeneralReport = async (
  pageNumber = 1,
  pageSize = 10,
  searchQuery = '',
  insuranceIPA = '',
  insurances = ''
) => {
  // Role scoping is resolved in the API/SP from RMT_UserID.
  // @InsuranceIPA expects CSV of labels (e.g. MCS-123), not numeric IPA.
  const params: Record<string, string | number> = {
    pageNumber,
    pageSize
  }
  if (searchQuery) params.SearchQuery = searchQuery
  if (insurances) params.insurances = insurances
  if (insuranceIPA) params.InsuranceIPA = insuranceIPA
  if (getUserRole() == Role.Staff) {
    const doctorId = localStorage.getItem('selectedDoctor')
    if (doctorId) params.doctorId = doctorId
  }
  const response = await axios.get(API_URL + `/GetGeneralReport`, { params })
  return response || null
}

export const getBFSReport = async (
  pageNumber = 1,
  pageSize = 10,
  searchQuery = '',
  insuranceIPA = '',
  insurances = ''
) => {
  const params: Record<string, string | number> = {
    pageNumber,
    pageSize
  }
  if (searchQuery) params.SearchQuery = searchQuery
  if (insurances) params.insurances = insurances
  if (insuranceIPA) params.InsuranceIPA = insuranceIPA
  if (getUserRole() == Role.Staff) {
    const doctorId = localStorage.getItem('selectedDoctor')
    if (doctorId) params.doctorId = doctorId
  }
  const response = await axios.get(API_URL + `/GetBFSReport`, { params })
  return response || null
}
export function getLoginSummary(
  p: GetUsersParams,
  insuranceIPA = '',
  insurances = ''
): Promise<AxiosResponse<LoginSummary[]>> {
  // Role scoping is resolved in the API/SP from RMT_UserID.
  // @InsuranceIPA expects CSV of labels (e.g. SSS-12345).
  const params: Record<string, string | number | boolean> = {
    pageNumber: p.pageNumber ?? 1,
    pageSize: p.pageSize ?? 25
  }
  if (p.searchQuery?.trim()) params.SearchQuery = p.searchQuery.trim()
  if (p.roleName) params.roleName = p.roleName
  if (p.active != null && p.active !== undefined) params.Active = p.active
  if (p.twoFA != null && p.twoFA !== undefined) params.TwoFA = p.twoFA
  if (insurances) params.insurances = insurances
  if (insuranceIPA) params.InsuranceIPA = insuranceIPA
  return axios.get<LoginSummary[]>('Authentication/GetLoginSummary', {
    params
  })
}
// export const getLoginSummary = async (
//   pageNumber = 1,
//   pageSize = 10,
//   searchQuery = '',
//   IPANumber = ''
// ) => {
//   const url = `Authentication/GetLoginSummary?pageNumber=${pageNumber}&pageSize=${pageSize}&SearchQuery=${searchQuery}&IPANumber=${IPANumber}`

//   const response = await axios.get(url)
//   return response || null
// }
export const getBSSReport = async (
  pageNumber = 1,
  pageSize = 10,
  searchQuery = '',
  insuranceIPA = '',
  insurances = ''
) => {
  const params: Record<string, string | number> = {
    pageNumber,
    pageSize
  }
  if (searchQuery) params.SearchQuery = searchQuery
  if (insurances) params.insurances = insurances
  if (insuranceIPA) params.InsuranceIPA = insuranceIPA
  if (getUserRole() == Role.Staff) {
    const doctorId = localStorage.getItem('selectedDoctor')
    if (doctorId) params.doctorId = doctorId
  }
  const response = await axios.get(API_URL + `/GetBSSReport`, { params })
  return response || null
}
export const getInsuranceAgreementsResolve = async (): Promise<InsuranceAgreementsResolve> => {
  const { data } = await axios.get(API_URL + `/InsuranceAgreementResolve`)
  return data
}
export const postInsurance = async (model: Insurance): Promise<SpResult[]> => {
  const { data } = await axios.post(API_URL, model)
  return data
}
export const postInsuranceAgreement = async (
  model: InsuranceAgreementsVM
): Promise<InsurancePostResult> => {
  const { data } = await axios.post(
    API_URL + `/CreateInsuranceAgreement`,
    model
  )
  return data
}
export const updateInsuranceStatus = async (
  model: UpdateInsuranceStatus
): Promise<UpdateInsuranceStatus[]> => {
  const { data } = await axios.put<UpdateInsuranceStatus[]>(
    API_URL + `/UpdateInsuranceStatus`,
    model
  )
  return data
}
export const editInsurance = async (
  model: UpdateInsurance
): Promise<SpResult[]> => {
  const { data } = await axios.put<SpResult[]>(
    API_URL + `/UpdateInsurance`,
    model
  )
  return data
}
export const updateInsuranceAgreement = async (
  model: UpdateInsuranceAgreement
): Promise<UpdateInsuranceAgreement[]> => {
  const { data } = await axios.put<UpdateInsuranceAgreement[]>(
    API_URL + `/UpdateInsuranceAgreement`,
    model
  )
  return data
}
export const deleteInsuranceAgreement = async (id: number): Promise<void> => {
  await axios.delete(API_URL + `/DeleteInsuranceAgreement`, {
    params: { id }
  })
}
export default {
  getInsurances,
  postInsurance,
  updateInsuranceStatus,
  editInsurance,
  getInsuranceAgreements,
  getInsuranceAgreementsResolve,
  postInsuranceAgreement,
  updateInsuranceAgreement,
  deleteInsuranceAgreement,
  getBSSReport,
  getBFSReport,
  getGeneralReport
}
